/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f125cbcfb9ce222f39ab5699a1875a3a7c338f34";
